module.exports = __webpack_public_path__ + "f5c53b831c2a6c73d07b208e07653c48.pdf";